<template>
    <!-- xl:w-[300px] lg:w-[200px] sm:w-[125px] w-[75px] -->
    <div v-if="!isLoading"
        style="height: 80px !important;"
        class="bg-[#0963FF] w-full flex justify-center items-center [clip-path:polygon(100%_0%,100%_70%,50%_100%,0%_70%,0%_0%)] relative">
        <h5 class="lg:text-lg text-sm font-medium text-[#ffffff] dark:text-gray-400 text-center">
            {{ packageData[nameKey] }}
        </h5>
        <div v-if="parseFloat(packageData?.discount) > 0" class="absolute rotate-[45deg] rtl:rotate-[-45deg] rtl:left-[-27px] rtl:top-[5px] left-[156px] top-[1px]">
            <strong class="block text-[0.9rem] py-[0.1rem] px-[2rem] ltr:pr-[1.4rem] rtl:px-[2rem] text-center bg-[#bd1919] text-white">
               {{ packageData?.discount }}%
            </strong>
        </div>
    </div>
    <div v-if="!isLoading" class="w-full flex-1 flex flex-col justify-between p-4 sm:p-2 h-full">
        <div class="flex flex-col items-center text-gray-900 dark:text-white">
            <!-- if discount not exist -->
            <span class=" lg:text-4xl  text-xl font-extrabold tracking-tight">
                {{ parseFloat(packageData?.discount) ? arabizeNumbers(Number(packageData?.basic_price) - (Number(packageData?.basic_price) * parseFloat(packageData?.discount) / 100)) : 
                arabizeNumbers(Number(packageData?.basic_price)) }}
            </span>

            <span class="ml-1 lg:text-sm text-xs font-normal text-[#9E9E9E] dark:text-gray-400">{{
                `${$t("user.upgrade.egyptian_pound")} /  ${packagePeriod}` }}</span>

            <span v-if="parseFloat(packageData?.discount) > 0" class="ml-1 lg:text-sm text-xs font-normal text-primary">
                {{ $t("user.upgrade.instead_of") }}
                </span>
                <span v-if="parseFloat(packageData?.discount) > 0" class="text-[#9E9E9E] line-through text-sm">
                    {{ arabizeNumbers(parseInt(packageData.basic_price)) }}
                    <span class="text-sm text-[#9E9E9E] line-through">
                    {{ $t("user.upgrade.egyptian_pound") }} /  {{ packagePeriod }}
                </span>
                </span>
        </div>
        
        <!-- Features List -->
        <div class="features-container flex-1 flex flex-col justify-center">
          <div
            :class="['features-scroll', showAllFeatures ? 'expanded' : 'collapsed']"
          >
            <ul role="list" class="space-y-2 my-4">
              <transition-group name="feature-fade" tag="div">
                <li
                  v-for="(feature, index) in displayedFeatures"
                  :key="index"
                  class="flex gap-1 sm:gap-2 items-start"
                >
                  <svg class="flex-shrink-0 w-4 h-4 text-blue-600 dark:text-blue-500 mt-0.5" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                  </svg>
                  <span class="text-[.8rem] sm:text-[.85rem] lg:text-[.9rem] font-normal leading-relaxed text-[#9E9E9E] dark:text-gray-400 break-words">
                    {{ feature }}
                  </span>
                </li>
              </transition-group>
              <li v-if="featuresList.length === 0" class="flex gap-1 sm:gap-2 items-start justify-center">
                <svg class="flex-shrink-0 w-4 h-4 text-gray-400 mt-0.5" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path
                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                </svg>
                <span class="text-[.8rem] sm:text-[.85rem] lg:text-[.9rem] font-normal leading-relaxed text-gray-400 italic">
                  {{ $t('user.upgrade.no_features_available') }}
                </span>
            </li>
        </ul>
          </div>
          <div v-if="featuresList.length > 1" class="flex justify-center pt-1">
            <button @click="toggleFeatures"
              :disabled="isToggling"
              class="group relative inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-blue-600 hover:text-blue-700 transition-all duration-300 rounded-xl hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 border border-transparent hover:border-blue-200 hover:shadow-sm active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed">
              <span class="relative z-10">{{ showAllFeatures ? $t('general.show_less') : $t('general.show_more') }}</span>
              <svg v-if="!isToggling"
                class="w-4 h-4 transition-all duration-300 group-hover:scale-110"
                :class="showAllFeatures ? 'rotate-180' : ''"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
              <svg v-if="isToggling" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span v-if="!showAllFeatures && !isToggling" class="text-xs text-gray-500 ml-1 relative z-10">
                ({{ featuresList.length - 1 }} {{ $t('general.more') }})
              </span>
              <div class="absolute inset-0 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </div>
        </div>
        
        <div class="relative flex items-center justify-center gap-3 mt-2 mb-0">
            <button @click="settingPackage(packageData)" type="button"
                :disabled="packageData.is_current"
                :class="`text-white font-semibold ${packageData.is_current ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#0963FF] hover:bg-blue-700'} focus:ring-4 focus:outline-none focus:ring-blue-200 dark:focus:ring-blue-900 rounded-[23px] lg:text-sm text-[.7rem] px-5 py-2.5 inline-flex justify-center w-full sm:w-[60%] text-center`">
                {{ packageData.is_current ? $t("user.upgrade.current_package") : $t("user.upgrade.subscribe_now") }}
            </button>
        </div>

    </div>
    <!-- skeleton packages card -->
    <div v-if="isLoading"
        class="animate-pulse bg-[#c7c7c7] w-full xl:h-[93px] lg:h-[85px] sm:h-[80px] h-[75px] flex justify-center items-center [clip-path:polygon(100%_0%,100%_70%,50%_100%,0%_70%,0%_0%)]">
    </div>
    <div v-if="isLoading" class="w-full animate-pulse flex-1 flex flex-col justify-between ju p-4 sm:p-2">
        <div class="flex flex-col items-center text-gray-900 dark:text-white">
        </div>
        <ul role="list" class="space-y-5 my-[6.5rem]">

        </ul>
        <div class="flex justify-center mt-5 mb-4">
            <button type="button"
                class="text-white animate-pulse font-semibold bg-[#c7c7c7]   focus:ring-blue-200   rounded-[23px]   lg:text-sm  text-[.65rem] px-5 py-5 inline-flex justify-center w-full sm:w-[60%] text-center">
            </button>

        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { useGlobalStore } from '@/store/Modules/global';
import { arabizeNumbers } from '~/helpers';
export default {
    name: 'packageCard',
    props: {
        packageData: {
            type: Object,
            required: false,
            default: []
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },

  
    },
    emits: ["changeCurrentPackage"],
    computed:{
        packagePeriod(){
            if(this.packageData?.months_period === 1){
                return this.$t("user.upgrade.per_month")
            }else if(this.packageData?.months_period === 12){
                return +this.packageData?.months_period + ' ' + this.$t("user.upgrade.per_month")
            }else if(this.packageData?.months_period === 6){
                return +this.packageData?.months_period + ' ' + this.$t("user.upgrade.months")
            }else if(this.packageData?.months_period === 3){
                return +this.packageData?.months_period + ' ' + this.$t("user.upgrade.months")
            }else{
                return this.$t("user.upgrade.months")
            }
        },
        isUser() {
            const global = useGlobalStore();
            return global?.currentUserRole == 'user';
        },
        nameKey() {
            return this.$i18n.locale === 'ar' ? 'name_ar' : 'name_en';
        },
        featuresList() {
            if (!this.packageData) return [];
            
            // Get features based on current locale
            const featuresText = this.$i18n.locale === 'ar' 
                ? this.packageData.features_ar 
                : this.packageData.features_en || this.packageData.features_ar;
            
            if (!featuresText) return [];
            
            // Split by newlines and filter out empty strings
            return featuresText.split('\n')
                .map(feature => feature.trim())
                .filter(feature => feature.length > 0);
        },
        displayedFeatures() {
            // Show only first feature initially, or all if showAllFeatures is true
            return this.showAllFeatures ? this.featuresList : this.featuresList.slice(0, 1);
        }
    },
    data() {
        return {

            v$: useVuelidate(),
            items: [],
            isProcessing: false,
            showPaymentModal: false,
            paymentMethod: 'card',//mobile_wallet // credit_wallet
            phone: '',
            showAllFeatures: false,
            isToggling: false,
        }
    },
    validations() {
        return { phone: { ...this.VALIDATIONS.phone }, }
    },
    methods: {
        arabizeNumbers,
        // checkout() {
        //     //check if coupon applied
        //     // if(!this.discount){
        //     //     this.setCouponState('notApplied')
        //     //     return
        //     // } 
        //     this.paymentMethod == 'mobile_wallet' && this.v$.$touch()
        //     if (this.paymentMethod == 'mobile_wallet' && this.v$.phone.$error) return

        //     this.isProcessing = true
        //     this.makeRequest({
        //         owner: this.MAINROLES.user,
        //         url: this.APIREQUESTS.user.checkout.url,
        //         method: this.APIREQUESTS.user.checkout.method,
        //         formData: JSON.stringify({
        //             package_id: this.packageData.id || '',
        //             ...(this.discount?.id && { coupon_id: this.discount.id }),

        //             payment_method: this.paymentMethod,
        //             ...(this.paymentMethod == 'mobile_wallet' && { phone: this.phone }),
        //         })
        //     })
        //         .then((res) => {
        //             if (!res || !res?.hasOwnProperty('status')) {
        //                 return;
        //             } else if (!res?.status) {
        //                 this.notify({ type: 'error', msg: res.message, });
        //             } else {
        //                 // succeeded
                       

        //                 if(this.paymentMethod == 'credit_wallet'){
        //                     this.notify({ type: 'success', msg: this.$t('general.payment_is_done_successfully') });
        //                     this.$router.replace(`${this.ROUTESNAMES.user.storeSettings}/create`)
        //                 }else if (Number(this.discount?.percent) === 100) {
        //                     this.notify({ type: 'success', msg: this.$t('general.done_successfully'), });
        //                     // no need to payment and goto create store
        //                     // goto create store
        //                     this.$router.replace(`${this.ROUTESNAMES.user.storeSettings}/create`)
        //                 } else {
        //                     this.notify({ type: 'success', msg: this.$t('general.done_successfully'), });
        //                     // need to payment 
        //                     // this.$router.replace(`${this.ROUTESNAMES.user.storeSettings}/create`)
        //                     // this.fawryCheckout({ 
        //                     //     merchantRefNum : res?.data?.id, 
        //                     //     price : res?.data?.price ,
        //                     //     customerMobile:user?.phone,
        //                     //     customerEmail:user?.email,
        //                     //     customerName:user?.first_name,
        //                     //     returnUrl:`${window.location.origin}${this.ROUTESNAMES.payment.state}/user`
        //                     // })
        //                     this.useLocalStorage({ type: 'set', key: 'payment_type', value: 'create' });
        //                     window.open(res?.data?.payment_url, "_blank")
        //                 }
        //                 //after payment success --->
        //                 //some changes in user in local, upgrade user to reseller and add selectedPackage 
        //                 let user = this.useLocalStorage({ type: "get", key: 'user' })
        //                 user = {
        //                     ...user,
        //                     role: 'reseller',//change role of user to reseller untill login again to change userobject form response
        //                     selectedPackage: this.packageData || {},//save package that reseller was selected in localstorage, 
        //                     packageWasSelected: true,//permission to access page store-settings/create
        //                 }
        //                 this.useLocalStorage({ type: 'set', key: 'user', value: user });
        //             }
        //         })
        //         .catch((err) => { //not succeeded
        //             // console.error(err);
        //             //case of Unauthenticated
        //             this.notify({
        //                 type: 'error',
        //                 msg: err?.data?.message || this.$t("general.unknown_error"),
        //             });
        //         }).finally(() => {
        //             this.isProcessing = false
        //             // this.setCouponState('init')
        //             this.closePaymentModal()
        //         })
        // },
 
        settingPackage(val){

            if(val){
                this.$emit('changeCurrentPackage' , val)

            }
        },
        toggleFeatures() {
            this.isToggling = true;
            this.showAllFeatures = !this.showAllFeatures;
            setTimeout(() => {
                this.isToggling = false;
            }, 300); // Match transition duration
        }

    },

}
</script>
<style scoped>
/* Ensure the card container can grow with content */
.flex-1 {
    flex: 1 1 auto;
    min-height: 0;
}

/* Features container styling */
.features-container {
    min-height: 60px; /* Decreased from 80px */
    transition: all 0.3s ease;
}

/* Feature fade transitions */
.feature-fade-enter-active,
.feature-fade-leave-active {
    transition: all 0.3s ease;
}

.feature-fade-enter-from {
    opacity: 0;
    transform: translateY(-10px);
}

.feature-fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.feature-fade-move {
    transition: transform 0.3s ease;
}

/* Button hover effects */
.group:hover .group-hover\:scale-110 {
    transform: scale(1.1);
}

/* Smooth rotation for arrow icon */
.rotate-180 {
    transform: rotate(180deg);
}

/* Custom button styling */
button:focus {
    outline: none;
    ring: 2px;
    ring-color: rgb(59 130 246);
    ring-offset: 2px;
}

/* Ensure consistent card height */
.h-full {
    height: 100%;
}

/* Card expansion animation */
.card-expanded {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Responsive height adjustments */
@media (max-width: 640px) {
    .features-container {
        min-height: 50px; /* Decreased from 70px */
    }
}

@media (min-width: 641px) and (max-width: 1024px) {
    .features-container {
        min-height: 65px; /* Decreased from 85px */
    }
}

@media (min-width: 1025px) {
    .features-container {
        min-height: 70px; /* Decreased from 90px */
    }
}

/* Smooth gradient animation for button */
.group:hover .bg-gradient-to-r {
    background-size: 200% 200%;
    animation: gradient-shift 0.3s ease;
}

@keyframes gradient-shift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}

.features-scroll {
  max-height: 2.5rem; /* collapsed: show 1-2 lines */
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4,0,0.2,1);
  position: relative;
}
.features-scroll.expanded {
  max-height: 180px; /* or whatever fits your design */
  overflow-y: auto;
}
.features-scroll::-webkit-scrollbar {
  width: 0 !important;
  display: none;
}
.features-scroll {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
}
</style>



<!-- <section class="flex justify-around items-center gap-5 p-10 h-full">
    <figure
        :class="`relative flex flex-col justify-between items-center h-full w-full sm:w-[40%] lg:w-[40%] min-w-[50px]  p-2  select-none cursor-pointer   hover:ring-4 rounded-md `">
        <img src="@/assets/upgrade/visa.png" :draggable="false" alt=""
            class="w-full  rounded-lg cursor-pointer products-images  object-cover" />
        <img src="@/assets/orders/success.svg" class="absolute  -right-2 -top-2  w-[10px] " alt="" />
        <figcaption>
            visa
        </figcaption>
    </figure>
    <figure
        :class="`relative flex flex-col justify-between items-center h-full w-full sm:w-[40%] lg:w-[40%] min-w-[50px]  p-2  cursor-pointer  hover:ring-4 rounded-md`">
        <img src="@/assets/upgrade/wallet.png" :draggable="false" alt=""
            class="w-full h-full  rounded-lg cursor-pointer products-images  object-cover" />
        <img src="" class="absolute top-[50%]  left-[50%] translate-x-[-50%] translate-y-[-50%] w-[40px] h-[40px] md:w-[60px] md:h-[60px]"
            alt="" />
        <figcaption>
            mobile wallet
        </figcaption>
    </figure>
</section> -->